// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"styles_tooltipContainer__o_LFW","tooltipArrowContainer":"styles_tooltipArrowContainer__LX1q9","tooltipArrowElement":"styles_tooltipArrowElement__mm8nS"};